import * as angular from 'angular';

dialogController.$inject = ['$mdDialog'];
export function dialogController($mdDialog) {

  this.closeThisDialog = closeThisDialog;
  this.cancelThisDialog = cancelThisDialog;

  ///////////////

  function closeThisDialog($event ?): void {
    return $mdDialog.hide($event);
  }

  function cancelThisDialog($event = {}): void {
    return $mdDialog.cancel($event);
  }

}

angular.module('controllers', [])
  .controller('DialogController', dialogController);



// WEBPACK FOOTER //
// ./resources/assets/js/common/dialogs/dialog.controller.ts